import {
  createListenerMiddleware,
  addListener,
  TypedStartListening,
  TypedAddListener,
} from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../types/sharedTypes';

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<
  RootState,
  AppDispatch
>;
